export const RuLocale = {
    page: {
        txtTitle: 'UNVOX | Мгновенно удалить вокал',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'логотип unvox',
        },
        action: {
            txtBack: 'Назад',
            txtRetry: 'Повторить',
            txtStartOver: 'Начать заново',
        },
        job: {
            txtCheckingStatus: 'Проверка статуса задачи',
            txtIdLabel: 'ID задачи',
        },
        footer: {
            linkPrivacyPolicy: 'Политика конфиденциальности',
            linkTerms: 'Условия',
            linkRefunds: 'Возвраты',
            linkSupport: 'Поддержка',
            txtAllRightsReserved: 'Все права защищены.',
            txtBugReportsAndFeatures: 'Отчеты об ошибках и запросы функций',
        },
        share: {
            title: 'UNVOX | Удаление вокала из песни в один клик',
            text: 'Легко превращайте любимые песни в инструменталы для караоке!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Удаление вокала в один клик',
            txtHeroSubtitle: 'Мгновенные инструменталы из вашего трека или напрямую с YouTube',
            txtInputTypeLabel: 'Тип ввода',
            txtInputTypeFile: 'Загрузить аудиофайл',
            txtInputTypeYoutube: 'Ссылка YouTube',
            txtInputFilePick: 'Выбрать файл',
            txtInputFileSub: 'Обычные аудиоформаты ({{formats}}), до {{size}} MB.',
            txtPreviewAction: 'Удалить вокал',
            txtPreviewFailed: 'Произошла неизвестная ошибка. Повторите попытку позже.',
            txtUploadSelectFile: 'Файл пока не выбран',
            txtYoutubeLabel: 'URL YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Вставьте публичную ссылку YouTube.',
            txtYoutubeMissing: 'Пожалуйста, вставьте URL YouTube.',
            txtYoutubeInvalid: 'Введите корректный URL YouTube.',
            txtYoutubeTooLong: 'Это видео длиннее 15 минут. Выберите более короткое видео.',
            txtCheckoutUploadFailed: 'Ошибка загрузки. Попробуйте еще раз.',
            txtUploadMissing: 'Перед загрузкой выберите файл.',
            txtFileTypeInvalid: 'Неподдерживаемый тип файла. Загрузите аудиофайл (например, {{formats}}).',
            txtFileTooLarge: 'Файл слишком большой. Максимальный размер: {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Не удалось создать предпросмотр',
            txtUnavailableBody: 'Произошла неизвестная ошибка. Повторите попытку позже.',
            txtPreparingTitle: 'Подготовка предпросмотра',
            txtPreparingBody: 'Это может занять до 2 минут',
        },
        payment: {
            txtUnavailableTitle: 'Не удалось создать предпросмотр',
            txtUnavailableBody: 'Произошла неизвестная ошибка. Повторите попытку позже.',
            txtPreparingTitle: 'Подготовка предпросмотра',
            txtCheckoutCancelledBody: 'Списаний не было. Вы можете попробовать снова в любое время.',
            txtTrackPreviewLabel: 'Предпросмотр трека',
            txtTrackPreviewHelper: 'Этот предпросмотр — 15-секундный фрагмент вашего трека для оценки',
            txtEmailLabel: 'Адрес электронной почты',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Мы используем это для отправки ссылки на скачивание.',
            txtCheckoutAction: 'Удалить вокал всего за {{price}}',
            txtCheckoutActionFallback: 'Удалить вокал',
            txtCheckoutFailed: 'Не удалось начать оплату. Попробуйте снова.',
            txtInvalidEmail: 'Введите корректный адрес электронной почты.',
        },
        processing: {
            txtMissingTitle: 'Отсутствует id задачи',
            txtMissingBody: 'Для этой страницы нужен id задачи. Начните новый предпросмотр.',
            txtMissingAction: 'Назад к загрузке',
            txtStatusFailed: 'Не удалось получить статус задачи. Попробуйте снова.',
            txtErrorTitle: 'Что-то пошло не так',
            txtSupportAction: 'Связаться с поддержкой',
            txtConfirmingTitle: 'Подтверждение платежа',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Проверка обновлений',
            txtWorkingTitle: 'Обработка полного трека',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Начать еще один',
            txtReadyTitle: 'Скачивание готово',
            txtReadyBody: 'Ваш инструментал готов к скачиванию.',
            txtDownloadAction: 'Скачать',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Начать еще один',
        },
        invalidJob: {
            txtTitle: 'Неверный id задачи',
            txtBody: 'Такая задача не найдена. Начните новую загрузку.',
            txtAction: 'Начать заново',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Поддержка',
            txtTitle: 'Связаться с поддержкой',
            txtLastUpdatedLabel: 'Последнее обновление',
            txtLastUpdatedDate: '9 февраля 2026',
            txtSectionEmailTitle: 'Email',
            txtSectionEmailBodyPrefix: 'Напишите нам на',
            txtSectionIncludeJobIdTitle: 'Укажите ID задачи',
            txtSectionIncludeJobIdBody: 'Пожалуйста, укажите ID задачи, чтобы мы быстрее нашли ваш запрос. Если вы оплатили, укажите email, использованный при оплате.',
            txtSectionBugReportsTitle: 'Отчеты об ошибках',
            txtSectionBugReportsBody: 'Вы также можете отправлять отчеты об ошибках и запросы функций по ссылке в футере.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Обратная связь',
            txtTitle: 'Отчеты об ошибках и запросы функций',
            txtSubtitle: 'UNVOX пока на ранней стадии. Если что-то работает не так или у вас есть идея, отправьте нам. Четкие отчеты помогают быстрее выпускать исправления.',
            txtWhatToIncludeTitle: 'Что включить',
            txtChecklistExpectedVsActual: 'Что вы ожидали и что произошло',
            txtChecklistSteps: 'Шаги для воспроизведения (1, 2, 3)',
            txtChecklistBrowserOs: 'Ваш браузер и ОС',
            txtChecklistJobId: 'ID задачи (если был связан с загрузкой)',
            txtTipTitle: 'Совет',
            txtTipBody: 'Если вы пишете нам по email, можно ответить прямо на письмо с доставкой и вставить шаблон.',
            txtTemplateTitle: 'Шаблон для копирования',
            txtTemplateBody: 'Отчет об ошибке / Запрос функции\n\nТип: bug | feature\nКратко:\n\nДетали:\n- Что произошло:\n- Что вы ожидали:\n- Шаги для воспроизведения:\n  1.\n- Браузер/ОС:\n\nНеобязательно:\n- ID задачи:\n- URL YouTube:\n- Скриншот/видео:\n',
            txtTemplatePageLabel: 'Страница',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'Копировать шаблон',
            txtCopyActionCopied: 'Скопировано',
            txtCopyActionFailed: 'Ошибка копирования',
            txtCopyHelpFailed: 'Доступ к буферу обмена заблокирован. Вы все равно можете выделить текст выше и скопировать его вручную.',
            txtCopyHelpIdle: 'Ничего отсюда не отправляется автоматически. Эта страница только помогает оформить хороший отчет.',
        },
    },
};
